import { render, staticRenderFns } from "./SlideXTransition.vue?vue&type=template&id=3fdb8fdc&"
var script = {}
import style0 from "./SlideXTransition.vue?vue&type=style&index=0&id=3fdb8fdc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports